import { AHCTheme } from './ahc/index.js';
import { theme } from '../theme.js';
import { JotTheme } from './jot/index.js';
import { QETestOrgTheme } from './qetestorg/index.js';

var ThemeVariant;
(function (ThemeVariant) {
  ThemeVariant["ENDPOINT"] = "Endpoint";
  ThemeVariant["AHC"] = "AHC";
  ThemeVariant["JOT"] = "Jot";
  ThemeVariant["QE_TEST_ORG"] = "QETestOrg";
})(ThemeVariant || (ThemeVariant = {}));
function getProviderThemeProps(themeVariant) {
  switch (themeVariant) {
    case ThemeVariant.AHC:
      return AHCTheme;
    case ThemeVariant.JOT:
      return JotTheme;
    case ThemeVariant.QE_TEST_ORG:
      return QETestOrgTheme;
    case ThemeVariant.ENDPOINT:
    default:
      return theme;
  }
}

export { getProviderThemeProps };
